import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
// import LeasingOnlineBanner from 'shared/components/LeasingOnlineBanner/LeasingOnlineBanner';
import SuggestForm from '../SuggestForm/SuggestForm';

// eslint-disable-next-line css-modules/no-unused-class
import s from './SuggestModal.css';

class SuggestModal extends React.Component {
  static propTypes = {
    // leasingParams: PropTypes.shape(),
    advert: PropTypes.shape().isRequired,
    show: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    // partner: PropTypes.string,
  };

  static defaultProps = {
    leasingParams: null,
    partner: '',
  };

  render() {
    const { advert, show } = this.props;
    return (
      <React.Fragment>
        {show && (
          <ModalContainer
            modalCN={s.modal}
            onClose={this.props.toggleModal}
            isOpen={this.props.show}
          >
            <div className={s.rootModal}>
              <div className={s.rootModalLeasing}>
                <SuggestForm
                  advert={advert}
                  modalMode
                  leasingParams={null}
                  toggleLeasingModal={this.props.toggleModal}
                />
                <i
                  className={cx({
                    'fa fa-times': true,
                    [s.closeBtnIcon]: true,
                  })}
                  onClick={this.props.toggleModal}
                />
              </div>
            </div>
          </ModalContainer>
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(s)(SuggestModal);



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestModal/SuggestModal.js